import VerificationWorkspace from '@/features/Verification/views/index.vue';

// Facility-scoped verification workspace route.
// IMPORTANT: Registered BEFORE taskRoutes in router/index.js so the /:id/:taskTypeId wildcard
// does not intercept /:id/verification/:taskId. See Frontend POV artifact §Risks (R1).
export default [
  {
    path: '/:id/verification/:taskId',
    name: 'verification-workspace',
    component: VerificationWorkspace,
    meta: {
      requiresAuth: true,
      facilityScope: true,
      layout: 'viewer-layout',
    },
  },
];
